import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Users, Download } from "lucide-react";
import { API, authHeaders } from "./AdminPage";
import { useAdminT } from "./adminI18n";

export const LeadsTab = () => {
  const { t } = useAdminT();
  const [leads, setLeads] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/admin/leads`, { headers: authHeaders() })
      .then((res) => setLeads(res.data))
      .catch(() => setLeads([]));
  }, []);

  const exportCsv = () => {
    const rows = [["Name", "Email", "Phone", "Source", "Date"]];
    leads.forEach((l) => rows.push([l.name, l.email, l.phone || "", l.source || "", (l.created_at || "").slice(0, 16).replace("T", " ")]));
    const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "themaya-leads.csv";
    a.click();
  };

  if (leads === null) {
    return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 text-luxury-gold animate-spin" /></div>;
  }

  return (
    <div data-testid="admin-leads-tab">
      <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
        <h2 className="font-serif text-3xl text-luxury-bone">العملاء المحتملون ({leads.length})</h2>
        {leads.length > 0 && (
          <button data-testid="leads-export-button" onClick={exportCsv}
            className="flex items-center gap-2 bg-luxury-gold text-luxury-black font-semibold px-5 py-2.5 rounded-full text-sm hover:bg-luxury-goldLight transition-colors">
            <Download className="w-4 h-4" strokeWidth={2} />
            {t("تصدير CSV (للنشرات البريدية)")}
          </button>
        )}
      </div>
      <p className="text-luxury-gray text-sm mb-6">
        {t("كل من يسجل في صفحات الهبوط أو نموذج التواصل يظهر هنا تلقائياً. صدّري القائمة CSV واستخدميها في خدمة نشرات مثل Mailchimp.")}
      </p>
      {leads.length === 0 ? (
        <div className="text-center py-16 text-luxury-gray">
          <Users className="w-10 h-10 mx-auto mb-4 text-luxury-gold" strokeWidth={1} />
          {t("لا يوجد عملاء محتملون بعد — أنشئي صفحة هبوط بهدية مجانية وابدئي الجمع")}
        </div>
      ) : (
        <div className="space-y-3">
          {leads.map((l, i) => (
            <div key={l.id || i} data-testid={`lead-row-${i}`} className="bg-luxury-surface border border-luxury-border p-5 flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="text-luxury-bone font-semibold">{l.name}</p>
                <p className="text-luxury-gold text-sm" dir="ltr">{l.email}</p>
              </div>
              <div className="text-left">
                <span className="text-xs border border-luxury-border text-luxury-gray rounded-full px-3 py-1">{l.source}</span>
                <p className="text-luxury-gray text-xs mt-2" dir="ltr">{(l.created_at || "").slice(0, 16).replace("T", " ")}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
